<div>
  <div mat-dialog-content class="text-center">
    <div class="alert alert-danger">
      This is a destructive action. Please confirm by entering the word
      <strong>"{{ this.operation.toUpperCase() }}"</strong> in the box below.
    </div>
    <mat-form-field floatLabel="never" appearance="outline">
      <input type="text" matInput [(ngModel)]="currentValue" value="{{ currentValue }}" />
      <mat-icon matSuffix class="pointer" (click)="clearField()">clear</mat-icon>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-center align-items-center">
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial mat-raised-button color="warn">CANCEL</button>
    <button
      class="btn"
      mat-stroked-button
      color="warn"
      [disabled]="currentValue != this.operation.toUpperCase()"
      (click)="submitForm()"
    >
      SUBMIT
    </button>
  </div>
</div>
